import { Color } from "./drawShapes";

export const hexColorToNumber = (color: Color = 0x000000 ): number => {
    if(typeof color === "number") return color;
    return parseInt(color.replace("#", ''), 16);
}